import { GRAPHQL_TAGS_QUERIES, GRAPHQL_TAGS_MUTATIONS } from 'graphql/tags'
import type {
  TagsQueriesName,
  TagsQueriesData,
  TagsQueriesVariables,
  TagsMutationsName,
  TagsMutationsVariables,
  TagsMutationsData,
} from 'graphql/tags/types'
import { buildQueryHook, buildMutationHook } from 'lib/apollo-client/builders'

export const useTagsQueries = buildQueryHook<TagsQueriesName, TagsQueriesVariables, TagsQueriesData>(
  GRAPHQL_TAGS_QUERIES
)

export const useTagsMutations = buildMutationHook<TagsMutationsName, TagsMutationsVariables, TagsMutationsData>(
  GRAPHQL_TAGS_MUTATIONS
)
